export default __webpack_public_path__ + "static/media/page-bg.8a6e3894.png";